import { render, staticRenderFns } from "./banner-ope.vue?vue&type=template&id=acb1b52a&scoped=true&"
import script from "./banner-ope.vue?vue&type=script&lang=js&"
export * from "./banner-ope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb1b52a",
  null
  
)

export default component.exports